(function($) {
    var buffer_overlap = 2; // px
    var state_before = '';
    var initialized = false;

    $(document).ready(function() { 
        function shouldDisableProductHover() {
            var ua = navigator.userAgent || '';
            var isIpad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            var isMobilePhone = /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|Opera Mini/i.test(ua);
            var isTouchTablet = navigator.maxTouchPoints > 0 && window.matchMedia('(max-width: 1366px)').matches;

            return isIpad || isMobilePhone || isTouchTablet;
        }

        if (shouldDisableProductHover()) {
            document.documentElement.classList.add('toh-disable-product-hover');
        }

        $('#wishlist-button').click(function() {
            $('.frcp-wishlist-link').click();
        })

        var CART_DRAWER_OPEN_KEY = 'toh:open-cart-drawer';

        function openCartDrawerAfterReload() {
            if (!sessionStorage.getItem(CART_DRAWER_OPEN_KEY)) return;
            sessionStorage.removeItem(CART_DRAWER_OPEN_KEY);

            var drawer = document.querySelector('cart-drawer-component');
            if (!drawer) return;
            if (typeof drawer.open === 'function') {
                drawer.open();
            }
        }

        openCartDrawerAfterReload();

        // Capture phase to block redirects even if other handlers are added later.
        document.addEventListener('click', function(e) {
            var target = e.target.closest('.swal2-confirm.frcp-btn.frcp-btn--primary');
            if (!target) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            sessionStorage.setItem(CART_DRAWER_OPEN_KEY, '1');
            window.location.reload();
        }, true);
        
        var FILTERS_OPEN_KEY = 'toh:filters-open';

        document.addEventListener('click', function(e) {
            var continueShoppingLink = e.target.closest('[data-continue-shopping-link]');
            if (!continueShoppingLink) return;
            sessionStorage.removeItem(FILTERS_OPEN_KEY);
        });

        function setFiltersOpen(isOpen) {
            if (isOpen) {
                sessionStorage.setItem(FILTERS_OPEN_KEY, '1');
            } else {
                sessionStorage.removeItem(FILTERS_OPEN_KEY);
            }
        }

        function applyFiltersOpenPreference() {
            if (!sessionStorage.getItem(FILTERS_OPEN_KEY)) return;
            var $collection = $('.collection-wrapper');
            if ($collection.length) $collection.removeClass('active');
        }

        function scheduleApplyFiltersOpenPreference() {
            if (!sessionStorage.getItem(FILTERS_OPEN_KEY)) return;
            for (var i = 0; i < 8; i++) {
                setTimeout(applyFiltersOpenPreference, i * 120);
            }
        }

        var filterFooterTimer = null;

        function hideFooterDuringFilterUpdate() {
            document.documentElement.classList.add('toh-hide-footer');

            if (filterFooterTimer) clearTimeout(filterFooterTimer);
            filterFooterTimer = setTimeout(function() {
                document.documentElement.classList.remove('toh-hide-footer');
            }, 1400);

            var resultsList = document.getElementById('ResultsList');
            if (!resultsList) return;

            var observer = new MutationObserver(function() {
                observer.disconnect();
                requestAnimationFrame(function() {
                    document.documentElement.classList.remove('toh-hide-footer');
                });
            });

            observer.observe(resultsList, { childList: true, subtree: true });
        }

        var collectionCardObserver = null;
        var collectionGridMutationObserver = null;

        function initCollectionCardScrollAnimation() {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

            var cards = document.querySelectorAll('.product-grid__item.animate--slide-in:not([data-animate-observed])');
            if (!cards.length) return;

            if (!('IntersectionObserver' in window)) {
                cards.forEach(function(card, index) {
                    card.setAttribute('data-animate-observed', '1');
                    card.style.setProperty('--animation-order', String(index));
                    card.classList.add('is-in-view');
                });
                return;
            }

            if (!collectionCardObserver) {
                collectionCardObserver = new IntersectionObserver(
                    function(entries, observer) {
                        entries
                            .filter(function(entry) {
                                return entry.isIntersecting;
                            })
                            .sort(function(a, b) {
                                return a.boundingClientRect.top - b.boundingClientRect.top;
                            })
                            .forEach(function(entry, index) {
                                entry.target.style.setProperty('--animation-order', String(index));
                                entry.target.classList.add('is-in-view');
                                observer.unobserve(entry.target);
                        });
                    },
                    {
                        root: null,
                        rootMargin: '0px 0px -25% 0px',
                        threshold: 0
                    }
                );
            }

            cards.forEach(function(card) {
                card.setAttribute('data-animate-observed', '1');
                collectionCardObserver.observe(card);
            });
        }

        function watchResultsListForCardAnimations() {
            if (collectionGridMutationObserver) {
                collectionGridMutationObserver.disconnect();
            }

            var resultsList = document.getElementById('ResultsList');
            if (!resultsList) return;

            collectionGridMutationObserver = new MutationObserver(function() {
                initCollectionCardScrollAnimation();
            });

            collectionGridMutationObserver.observe(resultsList, { childList: true, subtree: true });
        }

        applyFiltersOpenPreference();
        initCollectionCardScrollAnimation();
        watchResultsListForCardAnimations();

        document.addEventListener('filter:update', scheduleApplyFiltersOpenPreference);
        document.addEventListener('filter:update', hideFooterDuringFilterUpdate);

        gsap.registerPlugin(Flip);

        const grid = document.querySelector(".product-grid");

        $('.facets--filters-title').click(function() {
            var $wrapper = $('.product-grid-wrapper');
            var $collection = $(this).closest('.collection-wrapper');

            if ($wrapper.length) {
                $wrapper.css('min-height', $wrapper.outerHeight(true) + 'px');
            }

            if (!grid) {
                $collection.toggleClass('active');
                if ($wrapper.length) $wrapper.css('min-height', '');
                return;
            }

            var items = Array.from(grid.querySelectorAll(".product-grid__item"));
            if (items.length === 0) {
                $collection.toggleClass('active');
                if ($wrapper.length) $wrapper.css('min-height', '');
                return;
            }

            var viewportH = window.innerHeight || document.documentElement.clientHeight;
            var buffer = viewportH * 0.25;
            var targets = items.filter(function(el) {
                var rect = el.getBoundingClientRect();
                return rect.bottom > -buffer && rect.top < (viewportH + buffer);
            });

            if (targets.length === 0) targets = items;
            if (targets.length > 80) targets = targets.slice(0, 80);

            const state = Flip.getState(targets);

            $collection.toggleClass('active');
            setFiltersOpen(!$collection.hasClass('active'));

            Flip.from(state, {
                duration: 0.35,
                ease: "power2.out",
                absolute: false,
                nested: false,
                scale: false,
                simple: true,
                prune: true,
                onComplete: function() {
                    if ($wrapper.length) $wrapper.css('min-height', '');
                }
            });

            setTimeout(function() {
                if ($wrapper.length) $wrapper.css('min-height', '');
            }, 100);
        })

        initHeight();
        initFooterAccordion();
        initSwiper();
        initFilter();
        initCartDrawer();
        initMobileHeader();
        initMobileFooter();
        scheduleInitFooter();
        $(window).on('load', scheduleInitFooter);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(scheduleInitFooter);
        }


        $(window).resize(function() {
            initHeight();
            initFooter();
            initMobileFooter();
        })
        // Find the header drawer or fallback class
        var $drawer = $('header-drawer, .header-drawer').first();
        if (!$drawer.length) return;

        // Wait until the custom element is defined (for .open/.close support)
        if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined('header-drawer').then(initDrawerWatcher);
        } else {
            initDrawerWatcher();
        }

        var inserted = false;
        function initMobileFooter() {
            if($(window).width() > 749) {
                $('.menu__item.social-icon-wrapper').remove();
                inserted = false;
                
                return;
            }

            if(inserted) return;

            var target = $('.shopify-section-group-footer-group  a[aria-label="Instagram"]').parent();

            if(!target.length) return;

            if($('a[aria-label="Instagram"]').length >= 2) return;

            var html = '<li class="menu__item paragraph social-icon-wrapper">';
            html += target.html();
            html += '</li>';

            if(!$('footer a[href^="/pages/contact"]').length) return;

            var parent = $('footer a[href^="/pages/contact"]').closest('.list-unstyled');

            $(parent).append(html);

            inserted = true;
        }

        function initDrawerWatcher() {
            var drawerEl = $drawer.get(0);
            var $details = $drawer.find('details').first();

            // Listen for <details> open/close
            if ($details.length) {
                $details.on('toggle', function () {                                        
                    if (this.open) {
                        // $('header-component').attr('data-sticky-state', 'active');
                        var header_height = $('#header-component').height();
                        if ($(window).scrollTop() < 10) {
                            header_height += $('.announcement-bar').outerHeight(true);
                        }

                        header_height -= buffer_overlap;

                        $('div[data-header-drawer]').css('top', header_height + 'px');

                        state_before = $('header-component').attr('data-sticky-state');
                        $('header-component').attr('data-sticky-state', 'active');
                    } else {                                                
                        $('header-component').attr('data-sticky-state', state_before);
                    }

                    $('body').toggleClass('drawer-open', this.open);
                });
            }
        }
    });

    var footerRO = null;
    function scheduleInitFooter() {
        if (window.requestAnimationFrame) {
            requestAnimationFrame(function() {
                requestAnimationFrame(initFooter);
            });
        } else {
            initFooter();
        }
    }

    function initFooter() {
        var $footer = $('footer').first();
        if (!$footer.length) return;

        var footerHeight = $footer.outerHeight(true);
        $('#MainContent').css('margin-bottom', footerHeight + 'px');

        if (window.ResizeObserver && !footerRO) {
            footerRO = new ResizeObserver(scheduleInitFooter);
            footerRO.observe($footer.get(0));
        }
    }

    function initMobileHeader() {
        $(document).on('click', 'header header-component li:has(.menu-drawer__menu--childlist) > a', function(e) {
            e.preventDefault();

            $(this).parent().find('.menu-drawer__menu--childlist').toggle();
        });
    }

    function initFilter() {
        if($('.filter-click').length <= 0) return;

        $(document).on('click', '.filter-click', function() {
            $(this).parent().addClass('expand');
        })

        $(document).on('click', '.filter-click-close', function() {
            $(this).parent().removeClass('expand');
        })
    }

    function initSwiper() {
        $('.carousel-swiper').each(function() {
            new Swiper(this, {
                centeredSlides: true,
                slidesPerView: 1.5,
                effect: 'coverflow',
                initialSlide: 1,
                coverflowEffect: {
                    rotate: 0,
                    slideShadows: false,
                    stretch: -20,
                },
            });
        });

        $('.reviews-swiper').each(function() {
            new Swiper(this, {
                slidesPerView: 1,
                slideToClickedSlide: true,
                spaceBetween: 50,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    750: {
                        slidesPerView: 2
                    }
                }
            });
        });
       
    }

    function initFooterAccordion() {
        $(document).on('click', 'accordion-custom summary.menu__heading', function() {
            if($(window).width() > 749) return;

            $('footer accordion-custom summary.menu__heading.expand').not(this).parent().find('.details-content').slideToggle(250);

            $('footer accordion-custom summary.menu__heading.expand').not(this).removeClass('expand');

            $(this).toggleClass('expand');

            $(this).parent().find('.details-content').slideToggle(250);
        })
    }

    function initHeight() {
        if($('#shopify-section-template--17828121018452__section_zKfhwf').length <= 0 || isMobile()) return;

        var maxHeight = 0;

        $('#shopify-section-template--17828121018452__section_zKfhwf .group-block-content .group-block-content .text-block:first-child').css('min-height', 'unset');

        $('#shopify-section-template--17828121018452__section_zKfhwf .group-block-content .group-block-content').each(function() {
            $(this).find('.text-block:first-child').each(function() {
                var height = $(this).outerHeight();

                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
        });

        $('#shopify-section-template--17828121018452__section_zKfhwf .group-block-content .group-block-content .text-block:first-child').css('min-height', maxHeight + 'px');
    }

    function initCartDrawer() {
        $(document).on('click', '.pre-checkout-popup .content-wrapper .close-btn, .pre-checkout-popup .background-overlay', function() {
            $('.pre-checkout-popup').hide();
        });

        $(document).on('click', 'header header-component .cart-drawer__summary .right-part .cart__ctas .cart__checkout-button.show-popup', function() {
            if($('.pre-checkout-popup').length <= 0) return $('header header-component .cart-drawer__summary .right-part .cart__ctas .cart__checkout-button.proceed-checkout').click();

            $('.pre-checkout-popup').show();
        });

        $(document).on('click', '.pre-checkout-popup .content-wrapper .continue-btn', function() {
            $('header header-component .cart-drawer__summary .right-part .cart__ctas .cart__checkout-button.proceed-checkout').click();
        });
    }

    function isMobile() {
        return $(window).width() < 1058;
    }

    function checkHeart() {
        if (isMobile()) return;

        var offsetx = window.offsetx;
        var initialx = window.initialx;
        var initialy = window.initialy;
        var scale = window.scale;

        var top = $(window).scrollTop();
        var height = $(window).height() / 4;
        var scrolled = top / height;

        if (top < height && !initialized) {
            var deltax = initialx + (-initialx * scrolled);
            $('header .heart-logo').css('left', 'calc(' + deltax + '% + ' + offsetx + 'px)');

            var deltay = initialy - (initialy * scrolled);
            $('header .heart-logo').css('top', deltay + 'px');

            var delta_scale = scale - ((scale - 1) * scrolled);
            $('header .heart-logo').css('transform', 'scale(' + delta_scale + ')');
        } else if (initialized) {
            $('header .heart-logo').css('left', '0');   
            $('header .heart-logo').css('top', '0');
            $('header .heart-logo').css('transform', 'scale(1)');
        }

        $('header .heart-logo').css('opacity', 1);
        initialized = true;
    }
})(jQuery)
